exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".App_row_2kMMx{display:-webkit-box;display:-ms-flexbox;display:flex}.App_left_1W7j4,.App_right_3yxFD{-webkit-box-flex:1;-ms-flex:1 0 0px;flex:1 0 0}.App_left_1W7j4{padding-right:8px}.App_right_3yxFD{padding-left:8px}", ""]);

// exports
exports.locals = {
	"row": "App_row_2kMMx",
	"left": "App_left_1W7j4",
	"right": "App_right_3yxFD"
};